import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.25, 0.1, 0.25, 1];

// Vertical slide + fade + slight blur on swap
export function WordCycle({
    words = [],
    interval = 2200,
    className = "",
    "data-testid": testId,
}) {
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        if (!words.length) return;
        const id = setInterval(() => setIdx((p) => (p + 1) % words.length), interval);
        return () => clearInterval(id);
        // `id` is local; setIdx is a stable React setter.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [words, interval]);

    return (
        <span
            className={`relative inline-block align-baseline overflow-hidden ${className}`}
            style={{ lineHeight: 1 }}
            data-testid={testId}
        >
            <AnimatePresence mode="wait">
                <motion.span
                    key={words[idx]}
                    initial={{ y: "70%", opacity: 0, filter: "blur(8px)" }}
                    animate={{ y: "0%", opacity: 1, filter: "blur(0px)" }}
                    exit={{ y: "-70%", opacity: 0, filter: "blur(8px)" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="inline-block display-text"
                    style={{ willChange: "transform, opacity, filter" }}
                >
                    {words[idx]}
                </motion.span>
            </AnimatePresence>
        </span>
    );
}

// Like WordCycle but with longer hold + heavier blur-morph crossfade
export function MorphWords({
    words = [],
    interval = 2800,
    className = "",
    "data-testid": testId,
}) {
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        if (!words.length) return;
        const id = setInterval(() => setIdx((p) => (p + 1) % words.length), interval);
        return () => clearInterval(id);
        // `id` is local; setIdx is a stable React setter.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [words, interval]);

    return (
        <span
            className={`relative inline-block ${className}`}
            style={{ minHeight: "1em" }}
            data-testid={testId}
        >
            <AnimatePresence mode="wait">
                <motion.span
                    key={words[idx]}
                    initial={{ opacity: 0, filter: "blur(18px)", scale: 0.96 }}
                    animate={{ opacity: 1, filter: "blur(0px)", scale: 1 }}
                    exit={{ opacity: 0, filter: "blur(18px)", scale: 1.04 }}
                    transition={{ duration: 1.1, ease: EASE }}
                    className="inline-block display-text"
                    style={{ willChange: "filter, opacity, transform" }}
                >
                    {words[idx]}
                </motion.span>
            </AnimatePresence>
        </span>
    );
}
